import type { ReactNode } from "react";

import { BrandMark } from "./homepage/BrandMark";
import { formatHebrewItemCount } from "./hebrew-copy";
import { WORK_GALLERY_PATH } from "./work-gallery/work-gallery-api";
import { CONTACT_PATH } from "./public-routes";

export type SiteHeaderLink = {
  href: string;
  label: string;
};

type SiteHeaderProps = {
  cartQuantity?: number;
  links?: readonly SiteHeaderLink[];
  showCart?: boolean;
};

const DEFAULT_LINKS: readonly SiteHeaderLink[] = [
  { href: "/products", label: "מוצרים" },
  { href: WORK_GALLERY_PATH, label: "העבודות שלנו" },
  { href: CONTACT_PATH, label: "צור קשר" },
  { href: "/account", label: "האזור האישי" },
];

export function SiteHeader({
  cartQuantity,
  links = DEFAULT_LINKS,
  showCart = true,
}: SiteHeaderProps) {
  const cartLabel = typeof cartQuantity === "number"
    ? `סל הקניות, ${formatHebrewItemCount(cartQuantity)}`
    : "סל הקניות";
  const accountLink = links.find(link => link.href === "/account");
  const primaryLinks = links.filter(link => link.href !== "/account");

  return (
    <header className="storefront-header hp-site-header">
      <a
        className="storefront-brand"
        href="/"
        aria-label="בית דפוס רק בשמחות — דף הבית"
      >
        <BrandMark />
        <span className="storefront-brand-copy">
          <strong>בית דפוס רק בשמחות</strong>
          <span>דפוס, שילוט ועיצוב בהתאמה אישית</span>
        </span>
      </a>

      {primaryLinks.length > 0 ? (
        <nav className="hp-site-nav" aria-label="ניווט ראשי">
          {primaryLinks.map(link => (
            <a key={`${link.href}-${link.label}`} href={link.href}>{link.label}</a>
          ))}
        </nav>
      ) : null}
      <div className="hp-site-header__actions">
        {accountLink ? <a className="hp-site-header__account" href={accountLink.href}>{accountLink.label}</a> : null}
        {showCart ? (
          <a
            className="storefront-cart-summary"
            href="/cart"
            aria-label={cartLabel}
          >
            <span>סל</span>
            {typeof cartQuantity === "number" ? <strong>{cartQuantity}</strong> : null}
          </a>
        ) : null}
      </div>
    </header>
  );
}

export function AccountChrome({ children }: { children: ReactNode }) {
  return (
    <div
      className="storefront-shell storefront-shell--warm-product account-shell"
      dir="rtl"
      lang="he"
    >
      <SiteHeader
        links={[
          { href: "/", label: "דף הבית" },
          { href: "/products", label: "מוצרים" },
          { href: WORK_GALLERY_PATH, label: "העבודות שלנו" },
          { href: CONTACT_PATH, label: "צור קשר" },
          { href: "/account", label: "החשבון שלי" },
        ]}
      />
      {children}
    </div>
  );
}
